import '../ghs-bottom/ghs-bottom';
import '../ghs-logo/ghs-logo';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-footer-bh.css.lit';
import '../ghs-icon/ghs-icon';
import '../../base/outline-container/outline-container';
import {
  packersLogo,
  roundedBig,
  roundedBorderBig,
  roundedBorderMedium,
  roundedBorderSmall,
  roundedMedium,
  roundedSmall,
} from './ghs-footer-bh-assets';
import { LightController } from '../../controllers/light-controller';
import globalStyles from './ghs-footer-global.css.lit';
import { LogoVariantType } from '../ghs-logo/ghs-logo';

/**
 * NOTE light dom targeting of <li> elements necessary to achieve appropriate margin/padding of accordion section items. This was implemented in the story, and must be implemented in the drupal template.
 */

/**
 * The Footer component
 *
 * @element ghs-footer-bh
 */
@customElement('ghs-footer-bh')
export class GhsFooterBh extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightController = new LightController(
    this,
    globalStyles,
    this.tagName.toLowerCase()
  );

  /**
   * The Microsite Context
   * @param microsite
   * @default bhLogoMain
   *
   * Using the logo type here because it is a preexisting type that bridges
   * all the microsites, the logo in the footer doesn't actually change.
   */

  @property({ type: String, reflect: true, attribute: 'microsite' })
  microsite: LogoVariantType = 'bhLogoMain';

  @property({ type: String, reflect: true, attribute: 'domain-variable' })
  domainVariable = '';

  render(): TemplateResult {
    return html`
      ${this.domainVariable === 'runbellin'
        ? html`
            <div class="footer-super-wrapper footer-run-wrapper">
              <div class="footer-brand-logo">
                <slot name="footer-brand-logo">
                  <ghs-logo
                    logo-variant="${this.microsite}"
                    site=${this.site}
                  ></ghs-logo>
                </slot>
              </div>
              <div class="rounded-wrapper">
                <div class="rounded-border big">${roundedBorderBig}</div>
                <div class="rounded-border medium">${roundedBorderMedium}</div>
                <div class="rounded-border small">${roundedBorderSmall}</div>
              </div>
              <div class="big rounded">${roundedBig}</div>
              <div class="medium rounded">${roundedMedium}</div>
              <div class="small rounded">${roundedSmall}</div>
              <div class="footer-wrapper">
                <outline-container>
                  <footer class="footer">
                    <div class="footer-wrap">
                      <div class="footer-top-supersection">
                        <div class="footer-logo-section">
                          <div class="footer-contact">
                            <div class="footer-contact-top">
                              <slot name="footer-contact"></slot>
                            </div>
                            <div class="footer-contact-bottom">
                              <div class="footer-social-icons">
                                <slot name="footer-social-icons"></slot>
                              </div>
                            </div>
                          </div>
                        </div>
                        <slot name="footer-menu-section"></slot>
                      </div>
                      <div class="footer-disclaimer-et-al-section">
                        <div class="footer-et-al-left">
                          <div class="footer-links">
                            <slot name="footer-links"></slot>
                          </div>
                        </div>
                      </div>
                      <div class="footer-copyright">
                        <slot name="footer-copyright"></slot>
                      </div>
                      <div class="packers-logo">${packersLogo}</div>
                      <div class="footer-btt">
                        <ghs-bottom site=${this.site}></ghs-bottom>
                      </div>
                    </div>
                  </footer>
                </outline-container>
              </div>
            </div>
          `
        : html`
            <div class="footer-super-wrapper">
              <div class="footer-brand-logo">
                <slot name="footer-brand-logo">
                  <ghs-logo
                    logo-variant="bhLogoMainWhite"
                    site=${this.site}
                  ></ghs-logo>
                </slot>
              </div>
              <div class="rounded-wrapper">
                <div class="rounded-border big">${roundedBorderBig}</div>
                <div class="rounded-border medium">${roundedBorderMedium}</div>
                <div class="rounded-border small">${roundedBorderSmall}</div>
              </div>
              <div class="big rounded">${roundedBig}</div>
              <div class="medium rounded">${roundedMedium}</div>
              <div class="small rounded">${roundedSmall}</div>
              <div class="footer-wrapper">
                <outline-container>
                  <footer class="footer">
                    <div class="footer-top-supersection">
                      <div class="footer-logo-section">
                        <div class="footer-contact">
                          <div class="footer-contact-top">
                            <slot name="footer-contact"></slot>
                          </div>
                          <div class="footer-contact-bottom">
                            <div class="footer-social-icons">
                              <slot name="footer-social-icons"></slot>
                            </div>
                            <div class="packers-logo">${packersLogo}</div>
                          </div>
                        </div>
                      </div>
                      <slot name="footer-menu-section"></slot>
                    </div>
                    <div class="footer-disclaimer-et-al-section">
                      <div class="footer-et-al-left">
                        <div class="footer-links">
                          <slot name="footer-links"></slot>
                        </div>
                        <div class="footer-copyright">
                          <slot name="footer-copyright"></slot>
                        </div>
                      </div>
                      <div class="footer-btt">
                        <ghs-bottom site=${this.site}></ghs-bottom>
                      </div>
                    </div>
                  </footer>
                </outline-container>
              </div>
            </div>
          `}
    `;
  }
}
